import React from 'react';
import { mergeClassLists } from 'tailwind-classlist';
import { classes } from './utils';

export default function List({ className = '', sublist = false, ...props }) {
  return (
    <ul
      className={mergeClassLists(
        classes.list,
        sublist ? classes.sublist : '',
        className
      )}
      {...props}
    />
  );
}

export { default as ListItem } from './ListItem';
